var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "betzone" },
    [
      _vm.betZoneFeatures.length > 1
        ? _c(
            "div",
            { staticClass: "betzone-tabs" },
            _vm._l(_vm.visibleTabs, function(tab) {
              return _c(
                "button",
                {
                  key: tab.value,
                  staticClass: "betzone-tab",
                  class: { active: _vm.activeTab === tab.value },
                  on: {
                    click: function($event) {
                      _vm.activeTab = tab.value
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.visibleFeatures, function(feature) {
        return _c(
          "div",
          { key: feature.value, class: feature.wrapperClass },
          [
            _c(
              feature.component,
              _vm._b({ tag: "component" }, "component", feature.props, false)
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45546f9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45546f9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/BetZone.vue
// module id = null
// module chunks = 